import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';

@Injectable()
export class UtilsService {
  static EMAIL_REGEXP = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i;
  // Allow urls from 'youtube' and 'vimeo'
  static VIDEO_MEDIA_REGEXP = /^.*((youtu.be\/|vimeo.com\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  // Comma separated string
  static TAGS_REGEXP = /^([^,]+[,])*[^,]*$/i;

  static createGuid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  static getQuestionsData(snapshot: ActivatedRouteSnapshot, dataScheme: any) {
    const questionsData = {};
    if (snapshot && dataScheme) {
      Object.keys(dataScheme).forEach((key) => (questionsData[key] = this.getDeepValue(snapshot, dataScheme[key])));
    }
    return questionsData;
  }

  static getDeepValue(source, field) {
    field = field.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    field = field.replace(/^\./, ''); // strip a leading dot
    const path = field.split('.');
    for (let i = 0, n = path.length; i < n; ++i) {
      const partName = path[i];
      if (source && partName in source) {
        source = source[partName];
      } else {
        return;
      }
    }
    return source;
  }

  static hasDeepValue(source, field) {
    if (!source || !field) return false;
    field = field.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    field = field.replace(/^\./, ''); // strip a leading dot
    const path = field.split('.');
    for (let i = 0, n = path.length; i < n; ++i) {
      const partName = path[i];
      if (source && partName in source) {
        source = source[partName];
      } else {
        return false;
      }
    }
    return true;
  }

  static deepMerge(obj1, obj2) {
    const result = { ...obj1 };

    for (const key in obj2) {
      // eslint-disable-next-line
      if (obj2.hasOwnProperty(key)) {
        if (obj2[key] instanceof Object && obj1[key] instanceof Object) {
          result[key] = this.deepMerge(obj1[key], obj2[key]);
        } else {
          result[key] = obj2[key];
        }
      }
    }

    return result;
  }

  static createTabsManager(route, tabGroup?: MatTabGroup, defaultTab: Object | MatTabChangeEvent = { position: 0 }) {
    const tabList = tabGroup ? tabGroup['_tabs']['_results'] : [];
    const tabsManager = {
      currentTab: defaultTab,
      search: window.location.search,
      tabList,
      setTab,
      unsubscribe: () => routeSubscription.unsubscribe()
    };
    const routeSubscription: Subscription = route.fragment.subscribe((hash) => {
      if (hash && tabList) {
        tabsManager.currentTab = tabList.find((value) => value.textLabel === hash);
        tabGroup.selectedIndex = tabsManager.currentTab['position'];
      }
    });

    function setTab(tab: MatTabChangeEvent) {
      if (tab) {
        const tabName = tab['tab']['textLabel'];
        tabsManager.currentTab = { position: tab['index'], textLabel: tabName };
        window.history.replaceState(null, '', `${window.location.pathname}#${tabName}${tabsManager.search}`); // eslint-disable-line
      }
    }
    return tabsManager;
  }

  static compareMaps(map1, map2) {
    let testVal;
    if (!(map1 && map2)) {
      return false;
    }
    if (map1.size !== map2.size) {
      return false;
    }
    for (const key of Array.from(map1.keys())) {
      const val = map1.get(key);
      testVal = map2.get(key);
      if (testVal !== val || (testVal === undefined && !map2.has(key))) {
        return false;
      }
    }
    return true;
  }

  /**
   * Get the language of browser
   * @private
   */
  public static getBrowserLanguageLocale(): string {
    const locale = localStorage.getItem('backofficelanguage') || 'en';
    if (locale === 'en') {
      return 'en-US';
    }
    return locale;
  }
}
